import type RootStore from "stores/RootStore";
import { RouteType } from "types/RouteType";
import { throwIfFailed } from "shared/dialogSubmit";
import PortainerConnectionsStore from "./PortainerConnectionsStore";

const portainerConnectionsRoute: RouteType[] = [
  {
    name: "Portainer Connections",
    path: "/infrastructure/portainer-connections",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Portainer Connections",
        enableRefreshButton: true,
        component: () => import("./PortainerConnections.Header"),
      },
      body: {
        component: () => import("./PortainerConnections.Body"),
        grayBackground: true,
      },
    },
    group: "Admin",
    // Connection management (create/edit/test/remove) is admin-only — it governs
    // each Portainer server's admin API key (root-equivalent on every host). The
    // API enforces the admin gate on writes; this route is admin-only so the view
    // itself is hidden from non-admins.
    requiresAuth: true,
    requiresAdmin: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      const store = rootStore.portainerConnectionsViewStore as PortainerConnectionsStore;
      store?.loadConnections();
    },
    dialogs: [
      {
        name: "PortainerConnectionFormDialog",
        title: "Portainer Connection",
        submitButtonText: "Save connection",
        component: () => import("./dialogs/PortainerConnectionForm.Body"),
        cancelButton: true,
        height: 460,
        onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
          // A refused save throws, so the dialog stays open with the reason in
          // its footer (shared/dialogSubmit).
          const store = rootStore.portainerConnectionsViewStore as PortainerConnectionsStore;
          throwIfFailed(await store.saveConnection(), store.formError, "The connection could not be saved.");
        },
        onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
          const store = rootStore.portainerConnectionsViewStore as PortainerConnectionsStore;
          return store.isFormValid;
        },
      },
    ],
  },
];

export default portainerConnectionsRoute;
